"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
/**
 * Represents Role information
 */
var Role = /** @class */ (function (_super) {
    __extends(Role, _super);
    function Role() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Role";
        /**
         * Id of the tenant
         */
        _this.tenantId = function () {
            _this.push(function (_) { return "tenantId"; });
        };
        /**
         * Id of the role
         */
        _this.roleId = function () {
            _this.push(function (_) { return "roleId"; });
        };
        /**
         * The name of the role
         */
        _this.name = function () {
            _this.push(function (_) { return "name"; });
        };
        /**
         * The permissions of the role
         */
        _this.permissions = function () {
            _this.push(function (_) { return "permissions"; });
        };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Role;
}(Array));
exports.Role = Role;
//# sourceMappingURL=Role.js.map